import { Table as MantineTable } from "@mantine/core";

type Props = {
  children: React.ReactNode;
};

const Table = ({ children }: Props) => {
  return (
    <MantineTable
      horizontalSpacing="md"
      verticalSpacing="xs"
      sx={{ tableLayout: "fixed", minWidth: 700, width: "100%" }}
    >
      {children}
    </MantineTable>
  );
};

export default Table;
